import { useState, useEffect } from 'react'

export const isAndroid = () => {
  const userAgent = navigator?.userAgent
  if (userAgent) {
    return /android/i.test(userAgent)
  }
  return false
}

export const isVisible = (ref) => {
  if (ref?.current) {
    const rect = ref.current.getBoundingClientRect()
    const viewportHeight = isAndroid() ? window?.innerHeight : window.visualViewport?.height
    const { top, bottom } = rect
    if (!viewportHeight) return false
    return top >= 0 && bottom <= viewportHeight
  }
}

export const scrollTop = (how = 'smooth') => {
  if (typeof window !== 'undefined') {
    const { hash } = window.location
    if (hash) return

    document && document.body && document.body.scrollTo({
      top: 0,
      behavior: how
    })
  }
}

export const focus = (ref, behavior = 'auto', override = false, block = 'center') => {
  if (!override && isVisible(ref)) {
    return
  }

  setTimeout(() => {
    ref.current.scrollIntoView({ behavior, block })
  }, 300)
}

export function useOnScreen (ref, options = {}) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    if (!ref?.current || typeof window === 'undefined' || !window.IntersectionObserver) return

    const observer = new window.IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      options
    )

    observer.observe(ref.current)
    return () => { observer.disconnect() }
  }, [ref?.current])

  return isIntersecting
}

export const isMobile = (width = 768) => {
  return typeof window !== 'undefined' ? window.innerWidth <= width : false
}
